import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { NgModule } from '@angular/core';
import { ApolloClientOptions, InMemoryCache, from } from '@apollo/client/core';
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'
import {APP_CONFIG_TOKEN, IAppConfig} from "./services/app-config/app-config";

export function createApollo(httpLink: HttpLink, config: IAppConfig): ApolloClientOptions<any> {
  const uri = `${config.api.url}/graphql/`;
  const removeTypenameLink = removeTypenameFromVariables();

  return {
    link: from([removeTypenameLink, httpLink.create({ uri, withCredentials: true })]),
    cache: new InMemoryCache()
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, APP_CONFIG_TOKEN],
    },
  ],
})
export class GraphQLModule {}

